import { render } from "./Card.vue?vue&type=template&id=43a61494"
const script = {}

import exportComponent from "C:\\Users\\Luke\\Documents\\GitHub\\mclg1.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__